export const SUPPLIERS = 'SUPPLIERS'
export const SUPPLIER = 'SUPPLIER'